import { Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { LucideAngularModule, PenLine } from 'lucide-angular';
import { NotificationService } from 'src/app/core/services/notification.service';
import { CustomActionsService } from 'src/app/shared/services/custom-actions.service';

/** Free-text climate commitments. Declarative only — never linked to reduction tips. */
@Component({
  selector: 'app-custom-actions',
  standalone: true,
  imports: [FormsModule, TranslocoModule, ButtonModule, InputTextModule, LucideAngularModule],
  templateUrl: './custom-actions.component.html',
})
export class CustomActionsComponent {
  private customActionsService = inject(CustomActionsService);
  private notificationService = inject(NotificationService);
  private translocoService = inject(TranslocoService);

  readonly PenLine = PenLine;

  customActions = this.customActionsService.customActions;
  newActionText = signal('');
  isAddingCustom = signal(false);
  isSaving = signal(false);

  addCustomAction(): void {
    const text = this.newActionText().trim();
    if (!text || this.isSaving()) return;

    this.newActionText.set('');
    this.isAddingCustom.set(false);
    this.save([...this.customActions(), text]);
  }

  cancelCustomAction(): void {
    this.newActionText.set('');
    this.isAddingCustom.set(false);
  }

  removeCustomAction(index: number): void {
    if (this.isSaving()) return;
    this.save(this.customActions().filter((_, i) => i !== index));
  }

  private save(customActions: string[]): void {
    this.isSaving.set(true);
    this.customActionsService.updateCustomActions(customActions).subscribe({
      next: () => this.isSaving.set(false),
      error: () => {
        this.isSaving.set(false);
        this.notificationService.error(
          this.translocoService.translate('objectives.sdgSaveError'),
        );
      },
    });
  }
}
